import { h } from "preact";
import css from "./style.scss";
import cx from "classnames";
import { svgIcons } from "../../helpers/svg-helpers";

const IconButton = ({ icon, onClick }) => {
  return (
    <button onClick={onClick} class={cx(css.wrapper)}>
      {svgIcons[icon]()}
    </button>
  );
};
export default IconButton;
